import type { useSingleton } from "@tippyjs/react";
import { canv } from "@/canv/global";
import { CommentsIcon } from "@/icons";
import { BottomBarItem } from "@/interface/BottomBar/BottomRightBar";
import { Tooltip } from "@/interface/ui/Tooltip";

type Props = {
    singletoneTarget: ReturnType<typeof useSingleton>[1];
    isActive: boolean;
    className?: string;
};

export const Comments = ({ singletoneTarget, isActive, className }: Props) => {
    const openCommentsWindow = () => canv.appInterface.commentsWindow.open();
    return (
        <Tooltip singleton={singletoneTarget} content="Список комментариев">
            <BottomBarItem className={className} active={isActive} onClick={openCommentsWindow}>
                <CommentsIcon />
            </BottomBarItem>
        </Tooltip>
    );
};
